var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container p-0"},[_c('JPIndex'),_c('VNIndex'),_c('CNIndex'),_c('HKIndex'),_c('TWIndex'),_c('KRIndex'),_c('LAIndex'),_c('SGIndex'),_c('INIndex'),_c('GBIndex'),_c('DEIndex'),_c('RUIndex'),_c('DJIndex')],1)}
var staticRenderFns = []

export { render, staticRenderFns }